import * as React from "react";

function IconAbsent(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 20 20" fill="none" {...props}>
      <g clipPath="url(#prefix__clip0_743_21646)">
        <path
          d="M10 1.667a8.333 8.333 0 100 16.667 8.333 8.333 0 000-16.667zm2.259 9.408a.834.834 0 01-.271 1.366.834.834 0 01-.913-.182L10 11.175 8.925 12.26a.833.833 0 01-1.183 0 .834.834 0 010-1.184L8.825 10 7.742 8.925a.837.837 0 011.183-1.183L10 8.825l1.075-1.083a.837.837 0 011.184 1.183L11.175 10l1.084 1.075z"
          fill="#FF4242"
        />
      </g>
      <defs>
        <clipPath id="prefix__clip0_743_21646">
          <path fill="#fff" d="M0 0h20v20H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

const MemoIconAbsent = React.memo(IconAbsent);
export default MemoIconAbsent;
